export const environment = {
    production: true,
    APIEndpoint: '/api',
    splitPaymentAPI: '/api',
    simplesNacionalAPI: '/api',
    //portal: '',
    scriptPortal: '',

    splitPaymentAPISwagger: 'http://localhost:8080/api/swagger-ui/index.html',
    APIEndpointSwagger: 'http://localhost:8080/api/swagger-ui/index.html',
    simplesNacionalAPISwagger: 'http://localhost:8082/api/swagger-ui/index.html',

    profile: 'offline'
};